import { Modal, Select, Tooltip } from "antd";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import styles from "../../../contacts/contactWidgets/contactFiles/filelistcenter.module.scss";
import { ChatService } from "../../../../base/chatService";
import {
  downloadAttachment, getcontactDetail, imageFormat,
  SearchFilter, Cookie, getFileSize, videoFormat
} from "../../../../base/utils";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { chatwindowDetails, contacts, contactwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../../models/model";
import { URButton } from "../../../../shared/widgets/button";

import ImageZoom from "../../chatsection/imagezoom";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";

import { SocketChatService } from "../../../../base/socketChatService";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { useSelector } from "react-redux";
import { config } from "../../../../base/constant";
import moment from "moment";
import ProfileAvatarGroup from "../../leftsidebar/profileavatargroup";
import VideoPlayer from "../../chatsection/videoPlayer";
import { updateOpenstate } from "../../../../base/socketChatService/utils";
import teamIcn from "../../../../styles/images/teamimg.svg";
type filePreviewprops = {
  isOpen?: any;
  data?: any;
  previewopen: Function;
  groupdata?: any;
  allFilesList?: any;

}

type filepreviewstate = {
  isopenmodel: boolean;
  filterIndex: any;
  deleteModelOpen: boolean;
  sharemodelopen: boolean;
  contactList: Array<any>;
  searchContactList: Array<any>;
  selectedmember: Array<any>;
  contactDetail: Array<any>;
  previewDeleteData: any;
  deletingFileInfo: any;
  fileDescription: any;
}
export default function FilePreview({ isOpen, data, previewopen, groupdata }: filePreviewprops) {
  let { allContacs }: contacts = store.getState().contactReducer;
  const chatWindow: contactwindowDetails = useSelector((state: initialStateModel) => state.contactWindowReducer);
  let { contactFileList } = chatWindow;
  const chatallWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let {chatWindowDetails} = chatallWindow;
  const contact: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let { fileListDetails } = contact;
  const socketChat = useRef<any>(null);
  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, [])
  groupdata = _.filter(groupdata, ((list) => {
    return ((list.message?.messageType === 'IMAGE' || list.message?.messageType === 'FILE') &&
      list.message?.messageType !== 'DELETED');
  }));

  const filemodelClose = () => {
    setpreviefiles({ ...previefiles, isopenmodel: false });
    previewopen();
    updateOpenstate(false);
    
  };

  let filterArray = _.filter(groupdata, ((datas: any) => {
    let msgBody = datas?.message?.body;
    return imageFormat.indexOf(msgBody.fileType) !== -1 || videoFormat.indexOf(msgBody.fileType) !== -1
  }));

  let filterIndex = _.findIndex(filterArray, ((ele: any) => {
    return ele.id === data.id;
  }));

  const [previefiles, setpreviefiles] = useState<filepreviewstate>({
    isopenmodel: isOpen, filterIndex: filterIndex, deleteModelOpen: false, sharemodelopen: false, selectedmember: [],
    contactList: allContacs, searchContactList: allContacs, contactDetail: [],
    previewDeleteData: contactFileList, deletingFileInfo: data, fileDescription: ""
  });

  const deletepreviewFile = () => {
    if (!(_.isUndefined(previefiles.deletingFileInfo))) {
      socketChat.current.deleteForEveryone(fileRes.id);
      setpreviefiles({ ...previefiles, deleteModelOpen: false });
      if (window.location.pathname === "/contacts") {
        if (_.isArray(contactFileList)) {
          let prvDeletedFile = _.findIndex(contactFileList, ((ele: any, index: any) => { return ele.id === fileRes.id; }));
          contactFileList.splice(prvDeletedFile, 1)
          store.dispatch({
            type: Types.CONTACT_FILES_LIST,
            payload: {
              isContactFile: true,
              contactFileList: contactFileList
            }
          });
        }
      } else {
        let prvDeletedFile = _.findIndex(fileListDetails, ((ele: any, index: any) => { return ele.id === fileRes.id; }));
        fileListDetails.splice(prvDeletedFile, 1)
        store.dispatch({
          type: Types.GET_FILES_LIST,
          payload: {
            isfile: true,
            fileListDetails: fileListDetails
          }
        });
      }
      toastInformation(config().IMAGEDELETED, 'success');
      filemodelClose()
    };
  }

  useEffect(() => {
    setpreviefiles({ ...previefiles, filterIndex: previefiles.filterIndex });
    document.onkeydown = function (e: any) {
      if(e.key === "ArrowRight"){
        next();
      } else if(e.key === "ArrowLeft"){
        before();
      }
 
    }
  }, [previefiles.filterIndex]);
  const next = () => {
    filterIndex = previefiles.filterIndex + 1;
    setpreviefiles({ ...previefiles, filterIndex: filterIndex });
  store.dispatch({
    type:Types.SET_IMG_INDEX,
    payload:{imgIndex:filterIndex}
  })
  };
  const before = () => {
    filterIndex = previefiles.filterIndex - 1;
    setpreviefiles({ ...previefiles, filterIndex: filterIndex });
    store.dispatch({
      type:Types.SET_IMG_INDEX,
      payload:{imgIndex:filterIndex}
    })
  };

  const downloadAlfilesfromAttach = (filedata: any) => {
    // let messageBody:any = JSON.parse(filedata?.message?.body)
    downloadAttachment(filedata);

  };
  const confirmDelete = () => {
    setpreviefiles({ ...previefiles, deleteModelOpen: true });
  };
  const closeSelection = () => {
    let deletedArray: any = [];

    store.dispatch({
      type: Types.SELECT_MESSAGE_ARRAY,
      payload: {
        selectMessageData: deletedArray
      }
    });

    setpreviefiles({ ...previefiles, deleteModelOpen: false });
  };
  const handleCancelforShare = () => {
    setpreviefiles({ ...previefiles, sharemodelopen: false, contactDetail: [], selectedmember: [] });
  };
  const onChangeSelectMembers = (e: any) => {

    let { userdetails }: LoginState = store.getState().loginReducer;
    let contact: any =
      e.map((item: string) => {
        return getcontactDetail(item.toString(), previefiles.contactList, userdetails);
      });
    setpreviefiles({
      ...previefiles, selectedmember: e,
      searchContactList: previefiles.contactList, contactDetail: contact
    });

  };
  const onSearchMembers = (value: any) => {

    let response = SearchFilter(previefiles.contactList, value.toLowerCase());
    setpreviefiles({ ...previefiles, searchContactList: response });

  };
  const shareFile = () => {
    if (previefiles.selectedmember.length < 1) return toastInformation("No contacts selected", "warning");
    if (!(_.isUndefined(filterArray[previefiles.filterIndex]))) {
      const sampledate = [];
      sampledate.push(filterArray[previefiles.filterIndex]);
      ChatService.forwardMessage(sampledate, previefiles.contactDetail, previefiles.fileDescription);
      //ChatService.forwardMessage(sampledate,previefiles.contactDetail);
      toastInformation('File shared successfully', 'success');
      setpreviefiles({ ...previefiles, sharemodelopen: false, contactDetail: [], selectedmember: [] });
      filemodelClose()
    }
  };
  const likeMessage = (likeData: any,fileRes:any) => {
    let input = {
      id: fileRes.id,
      likeStatus: likeData
    };
    socketChat.current.likeMessageInfo(input);
  };
  const saveMessage = (status: any,fileRes:any) => {
    if(status===1){
      toastInformation("Sucess! Message saved");
    }
    let isBookmark = {
      id: fileRes.id,
      saveStatus: status
    };

    socketChat.current.bookMarkMesseage(isBookmark);
    status === 1 && toastInformation('Sucess! Message saved','success');
  };
  const openReplyMessage = (data:any) => {
      ChatService.onChangeReplyWindow(true, data);
      filemodelClose()
  };

  
  let fileDetails = filterArray[previefiles.filterIndex]?.message?.body;
  let len = Math.ceil((previefiles?.searchContactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  let fileRes:any = filterArray[previefiles.filterIndex]; 
  let LikeObeject: any = fileRes?.message?.liked || [];
  let isBookmark: any = fileRes?.message?.isSave || [];
  let isLike = (LikeObeject && LikeObeject["s" + userdetails.sip_login_id]) || 0;
  let savedBookmark = (isBookmark && isBookmark["s" + userdetails.sip_login_id]) || 0;

 
  function previewClose(e: any): void {
    if(e.keyCode === 27){
      filemodelClose();
    }
  }
  const maxFileNameLength = 30; 
  const truncateFileName = (fileName:any) => {
    if (fileName?.length> maxFileNameLength) {
      const extensionIndex = fileName?.lastIndexOf('.'); 
      if (extensionIndex !== -1)
       {
        const nameWithoutExtension = fileName?.slice(0, extensionIndex); 
        const truncatedName = nameWithoutExtension?.slice(0, maxFileNameLength - 3);
        const extension = fileName?.slice(extensionIndex);
        return truncatedName + '...' + extension;
      } else {
        return fileName?.slice(0, maxFileNameLength - 3) + '...';
      }
    }
    return fileName;
  };
  return (
    <>

      <Modal  onCancel={(e)=>previewClose(e)} visible={previefiles.isopenmodel} className="imagepreviewmodal">
        <div className="modalheaders">

          <div className="previewHead">
          <ProfileAvatarGroup contactDetail={chatWindowDetails} profileSize={42} randomColor={random_color[8]} ></ProfileAvatarGroup>
           <h2>
              {/* {fileDetails?.fileName} */}
              {truncateFileName(fileDetails?.fileName)}
              <span className="chatTime">{ moment(fileRes?.timestamp).format('hh:mm A')}</span>
            </h2>

          </div>

          <ul>
            {/* <li onClick={() => openReplyMessage(fileRes)}> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Reply'}>
              <span className="iconReply">
              </span></Tooltip></li> */}
            <li onClick={() => saveMessage((savedBookmark === 0 ? 1 : 0),fileRes)}> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ? "Save Chat" : "UnSave chat"}>
              <span className={savedBookmark === 0?"iconSaveChat":"iconUNSaveChat"}></span></Tooltip></li>
            <li onClick={() => likeMessage((isLike === 0 ? 1 : 0),fileRes)}> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={isLike === 0 ? "Like" : "Unlike"}>
              <span className="iconLike" ></span></Tooltip></li>
            <li><Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Download'}>
              <span className="iconDownloadstroke"
                onClick={() => downloadAlfilesfromAttach(fileRes)}></span></Tooltip></li>


            {(window.location.pathname.includes('contact') && userdetails?.sip_login_id.toString() === filterArray[previefiles.filterIndex]?.from.toString() ?
              <Tooltip mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                <li><span className="iconDelete" onClick={confirmDelete}></span></li></Tooltip> :

              window.location.pathname.includes('chat') && userdetails?.sip_login_id.toString() === filterArray[previefiles.filterIndex]?.from.toString() &&
              <Tooltip mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                <li><span className="iconDelete" onClick={confirmDelete}></span></li></Tooltip>
            )}
            <li> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Share'}>
              <span className="iconShare" onClick={()=>
                 setpreviefiles({...previefiles,sharemodelopen:true})
               }></span></Tooltip></li>
              {/* <li> <Tooltip overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'More'}>
              <span className="iconOverflowH" ></span></Tooltip></li> */}
            <li><Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Close'}
            >
              <span className="iconClose" onClick={filemodelClose}>
              </span></Tooltip></li>
              
          </ul>
        </div>
        <div className="imagepreview">

          {previefiles.filterIndex > 0 &&
            <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top"
              title={'Swipe Left'}><div className="leftcarosuel"><span className="iconStrokeleftarrow " onClick={before}>
              </span></div></Tooltip>}
          {previefiles.filterIndex < filterArray.length - 1 && <Tooltip overlayClassName='customTooltip' placement="top" title={'Swipe Right'}>
            <span className="iconStrokerightarrow rightcarosuel" onClick={next}></span></Tooltip>}
            {videoFormat.indexOf(fileRes?.message?.body?.fileType) !== -1 ? <VideoPlayer data={filterArray[previefiles.filterIndex]}></VideoPlayer> : 
          <ImageZoom data={filterArray[previefiles.filterIndex]} ></ImageZoom> 
          }
        </div>
      </Modal>
      <Modal title="Delete file"
        centered
        visible={previefiles.deleteModelOpen}
        onOk={deletepreviewFile}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected file?
      </Modal>
      <Modal visible={previefiles.sharemodelopen} className={`${styles.addmembermodal} ${"modaloverwrite"}`}>
        <div className={styles.drop}>
          <span className={`icon_close ${styles.cursorTop}`}
            onClick={handleCancelforShare}></span>
          <h2>Share this file</h2>
          <div className={styles.insideicon}>
            {/* <img src={taskimg2} alt="" /> */}
            <Select
              mode="multiple"
              onChange={(e: any) => onChangeSelectMembers(e)}
              onSearch={onSearchMembers}
              style={{ width: '100%' }}
              filterOption={false}
              showSearch={true}
              value={previefiles.selectedmember}
              placeholder="Search Name / Group/ Extension"
              className="createNewSel"
              dropdownClassName="newChatSel">
              {previefiles?.searchContactList?.map((contact: any, index: any) => {

                let name = contact?.caller_id ? contact?.caller_id : contact?.team_name;
                return (

                  <option key={index}
                    value={contact?.sip_login_id ? contact?.sip_login_id : `con${contact?.team_id}`}>
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                     
                    {contact?.team_id ? <URAvatarGroup className={`lefts size20 colorBG${random_color[index]} 
                    ${(contact?.profile_image_url!== null && contact?.profile_image_url !== "")?'avatarWithImg':""}`}
                    profileInfo={ <> {contact?.profile_image_url ?
                      <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>:
                      <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> } </>  }
                  /> :    <URAvatarGroup
                  className={`lefts size20 colorBG${random_color[index]} ${(contact?.ImageURL!== null && contact?.ImageURL !== "")?'avatarWithImg':""}`}
                  profileInfo={
                    <>
                      {contact?.ImageURL || contact?.profile_image_url ? (
                        <>
                          <img alt="" src={contact?.ImageURL ? contact.ImageURL : contact?.profile_image_url} />
                          <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                        </>
                      ) : (
                        <span>
                          {contact?.first_name?.charAt(0).toUpperCase()+contact?.last_name?.charAt(0).toUpperCase()}
                          <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                        </span>
                      )}
                    </>
                  }
                />}
                      </div>
                      <div className="names">{name && name}</div>
                      {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                    </div>
                  </option>

                );


              })}

            </Select>
            {/* <div className={styles.insideicon}>
              <TextArea rows={3} title="Add a message, if you'd like." placeholder="Add a message, if you'd like."
                onChange={(e) => addFileDescription(e)} className="notesArea" />
            </div> */}
          </div>
          <div className={styles.lftImfseccont}>
            <img src={fileDetails?.filePath} alt="" />
            {/* <p><span>{fileDetails?.fileName}</span> */}
            <p><span>{truncateFileName(fileDetails?.fileName)}</span>
              <span>File size:{getFileSize(fileDetails?.filesize)}</span></p>
          </div>
          {/* <div className={styles.lftImfseccont}>
 

{
  zipFormats.indexOf(filterArray[previefiles.filterIndex]?.fileType) !== -1 ?
    <img src={iconzip} alt=""/>
    :
    pdfFormats.indexOf(filterArray[previefiles.filterIndex]?.fileType) !== -1 ?
      <img src={iconpdf} alt=""/>:
      wordFormats.indexOf(filterArray[previefiles.filterIndex]?.fileType) !== -1 ?
        <img src={iconword} alt=""/>:
        pptFormats.indexOf(filterArray[previefiles.filterIndex]?.fileType) !== -1 ?
          <img src={iconppt} alt=""/>:
          excelFormats.indexOf(filterArray[previefiles.filterIndex]?.fileType) !== -1&&
 
<img src={iconxls} alt=""/>}
<p><span>{filterArray[previefiles.filterIndex]?.fileName}</span>
  <span>File size:{filterArray[previefiles.filterIndex]?.fileSize
    ?filterArray[previefiles.filterIndex]?.fileSize:"0 kb"}</span></p>
</div> */}
          <div className={styles.footersection}>
            <URButton className={styles.cancelbtn}

              name="Cancel" onClick={handleCancelforShare}></URButton>
            <URButton className={styles.savebtn} onClick={shareFile} name="Share"></URButton>
          </div>
        </div>
      </Modal>
    </>
  );
}